import { gql } from "@apollo/client";

export const LATEST_SHIELDS_QUERY = gql`
    query LatestShields($count: Int) {
        latestShields(count: $count) {
            id
            imageUrl
            shieldNumber
            playerName
        }
    }
`;
